import { createAction, props } from '@ngrx/store';
import { DateTime } from 'luxon';
import { Notification } from '../../interfaces/notification';

export const loadNotificationsLazy = createAction('[Notification/API] Load Notifications Lazy');

export const loadNotificationsPolling = createAction('[Notification/API] Load Notifications Polling');

export const loadNotificationsLazySuccess = createAction(
  '[Notification/API] Load Notifications Lazy Success',
  props<{ notifications: Notification[]; overall: number; unseen: number; lastPoll: DateTime }>()
);

export const loadNotificationsPollingSuccess = createAction(
  '[Notification/API] Load Notifications Polling Success',
  props<{ notifications: Notification[]; overall: number; unseen: number; lastPoll: DateTime }>()
);

export const loadNotificationsFailure = createAction(
  '[Notification/API] Load Notifications Failure',
  props<{ error: any }>()
);

export const toggleNotificationState = createAction(
  '[Notification/API] Toggle Notification State',
  props<{ notification: Notification }>()
);

export const toggleNotificationStateSuccess = createAction(
  '[Notification/API] Toggle Notification State Success',
  props<{ notification: Notification }>()
);

export const toggleNotificationStateFailure = createAction(
  '[Notification/API] Toggle Notification State Failure',
  props<{ error: any }>()
);

export const markAllNotificationsAsSeen = createAction('[Notification/API] Mark all Notifications as seen');

export const markAllNotificationsAsSeenSuccess = createAction(
  '[Notification/API] Mark all Notifications as seen Success'
);

export const markAllNotificationsAsSeenFailure = createAction(
  '[Notification/API] Mark all Notifications as seen Failure',
  props<{ error: any }>()
);

export const clearNotifications = createAction('[Notification/API] Clear Notifications');

export const setInitialState = createAction('[Notification/API] Initial state set');
